import axios from 'src/utils/axios'
// routes
import { paths } from 'src/routes/paths'
import { useAuthStore } from 'src/store/auth'

// ----------------------------------------------------------------------

export function jwtDecode(token: string) {
  const base64Url = token.split('.')[1]
  const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/')
  const jsonPayload = decodeURIComponent(
    window
      .atob(base64)
      .split('')
      .map((c) => `%${`00${c.charCodeAt(0).toString(16)}`.slice(-2)}`)
      .join(''),
  )

  return JSON.parse(jsonPayload)
}

// ----------------------------------------------------------------------

export const isValidToken = (accessToken: string) => {
  if (!accessToken) {
    return false
  }

  try {
    const decoded = jwtDecode(accessToken)
    const currentTime = Date.now() / 1000
    return decoded.exp > currentTime
  } catch {
    return false
  }
}

// ----------------------------------------------------------------------

let expiredTimer: ReturnType<typeof setTimeout> | null = null

export const tokenExpired = (exp: number) => {
  const currentTime = Date.now()
  const timeLeft = exp * 1000 - currentTime

  if (expiredTimer) {
    clearTimeout(expiredTimer)
  }

  if (timeLeft <= 0) {
    useAuthStore.getState().logout()
    window.location.href = paths.auth.login
    return
  }

  expiredTimer = setTimeout(() => {
    useAuthStore.getState().logout()
    window.location.href = paths.auth.login
  }, timeLeft)
}

// ----------------------------------------------------------------------

export const setSession = (accessToken: string | null) => {
  if (accessToken) {
    axios.defaults.headers.Authorization = `Bearer ${accessToken}`

    useAuthStore.getState().setToken(accessToken)
  } else {
    useAuthStore.getState().logout()

    delete axios.defaults.headers.Authorization
  }
}
